export const getCookie = (cookieName: string): string | null => {
  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  const findCookie = cookies.find((cookie: string) => {
    const [name, _value] = cookie.split("=");
    return name === cookieName;
  });
  return findCookie ? findCookie.split("=")[1] : null;
};

export const setCookie = (
  cookieName: string,
  value: string,
  expires: string,
  path = "/",
) => {
  document.cookie = `${cookieName}=${value}; expires=${expires}; path=${path}`;
};

export const deleteCookie = (cookieName: string) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
